import { ChangeEvent, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import Loader from "Components/Loader";
import { useGetProductsQuery } from "hooks/ProductsManagement/useGetProductsQuery";
import DashboardLayout from "Layout/DashboardLayout";
import BasicIinformationForm from "./Components/BasicIinformationForm";
import ShippingAndInventoryForm from "./Components/ShippingAndInventoryForm";
import EditUploadImageForm from "./EditComponents/EditUploadImageForm";
import { useUpdateProductsMutation } from "hooks/ProductsManagement/useUpdateProductsMutation";

const CatalogEditPage = () => {
  const { id } = useParams();
  const { data, isFetching } = useGetProductsQuery({ id });
  const [active, setActive] = useState(0);
  const [payload, setPayload] = useState<any>(null);

  const [validity, setValidity] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const { mutateAsync } = useUpdateProductsMutation(id);

  const handleSubmit = () => {
    setIsLoading(true);
    mutateAsync(payload, {
      onSuccess: () => {
        navigate("/product-management");
      },
    });
  };

  useEffect(() => {
    if (data?.data) {
      setPayload(data.data);
    }
  }, [data]);

  useEffect(() => {
    if (!payload) return;

    const {
      name,
      unitPrice,
      bulkPrice,
      unitStockMeasurement,
      bulkStockMeasurement,
    } = payload;

    const requiredFieldsValid = Boolean(
      name &&
        unitPrice &&
        bulkPrice &&
        unitStockMeasurement &&
        bulkStockMeasurement
    );
    setValidity(requiredFieldsValid);
  }, [payload]);

  const convertPricesToNaira = (product: any) => {
    return {
      ...product,
      unitPrice: product.unitPrice / 100,
      bulkPrice: product.bulkPrice / 100,
    };
  };
  useEffect(() => {
    if (data?.data) {
      const updatedData = convertPricesToNaira(data.data);
      setPayload(updatedData);
    }
  }, [data]);

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setPayload((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <DashboardLayout title="Edit Product" back={true}>
      {isFetching && <Loader />}
      {!isFetching && payload && (
        <div>
          <div className="flex border-b-[1px] border-[#eeeeee] mb-3">
            <div
              className={`px-[10px] py-[13px] cursor-pointer ${
                active === 0 ? "text-orange bg-[#FFF5F0]" : "text-[#a8a8a8]"
              }`}
              onClick={() => setActive(0)}
            >
              (1) Basic Information
            </div>
            <div
              className={`px-[10px] py-[13px] cursor-pointer ${
                active === 1 ? "text-orange bg-[#FFF5F0]" : "text-[#a8a8a8]"
              }`}
              onClick={() => setActive(1)}
            >
              (2) Upload images
            </div>
            <div
              className={`px-[10px] py-[13px] cursor-pointer ${
                active === 2 ? "text-orange bg-[#FFF5F0]" : "text-[#a8a8a8]"
              }`}
              onClick={() => setActive(2)}
            >
              (3) Shipping and inventory
            </div>
          </div>
          {active === 0 && (
            <BasicIinformationForm
              edit={true}
              active={active}
              payload={payload}
              setActive={setActive}
              setPayload={setPayload}
              handleInputChange={handleInputChange}
              handleSubmit={handleSubmit}
              validity={validity}
              isLoading={isLoading}
            />
          )}
          {active === 1 && (
            <EditUploadImageForm
              edit={true}
              active={active}
              payload={payload}
              setActive={setActive}
              setPayload={setPayload}
              handleInputChange={handleInputChange}
              handleSubmit={handleSubmit}
              validity={validity}
              isLoading={isLoading}
            />
          )}
          {active === 2 && (
            <ShippingAndInventoryForm
              active={active}
              edit={true}
              payload={payload}
              setPayload={setPayload}
              setActive={setActive}
              handleInputChange={handleInputChange}
              handleSubmit={handleSubmit}
              validity={validity}
              isLoading={isLoading}
            />
          )}
        </div>
      )}
    </DashboardLayout>
  );
};

export default CatalogEditPage;
